import { createPortal } from 'react-dom';
import { Modal } from '../../Components';
import { toggleShow } from '../../Slicers/modalSlice';
import { ReactComponent as BigAlert } from "src/Themes/assets/BigAlert.svg";
import { useAppDispatch, useAppSelector } from 'src/Hooks';
import { HelpModal } from 'src/Views/Help';
import "./InfoModal.scss";

/**   */
export enum ModalTypes {
    info,
    debug,
    error,
	green,
	help
};

/**   */
const InfoModal = () => {

	const { isShow, title, type, text, fullHelp } = useAppSelector( store => store.modal );
	const dispatch = useAppDispatch();
	const onClose = () => dispatch( toggleShow() );

	const getClsByType = () => {
		switch(type) {

			case ModalTypes.error: 
				return "brd-error";

			case ModalTypes.info: 
			default: 
				return "brd-info";
		}
	};

	const getColorByType = () => {
		switch(type) {

			case ModalTypes.error: 
				return "error";

			case ModalTypes.green: 
			default: 
				return "green";
		}
	};

	const renderMessageModal = () => (
		<Modal
			isOpen={isShow}
			title={title}
			onClose={() => dispatch(toggleShow())}
			className={getClsByType()}
			color={getColorByType()}
			renderIcon={ type === ModalTypes.error ? <BigAlert /> : null }
		>
			<div dangerouslySetInnerHTML={{ __html: text }} />
		</Modal>
	);

	const renderModal = () => {
		if ( !isShow ) return null;
		if ( type === ModalTypes.help ) 
			return (
				<HelpModal isFull={fullHelp} onClose={onClose} />
			);
		else 
			return renderMessageModal();
	};

	return createPortal( renderModal(), document.body );
};

export default InfoModal;
